import { useMemo } from 'react';

import { RelationType } from 'api/types/entity';
import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import {
  Field,
  useFormContext,
} from 'modules/client/common/forms/pepConnectionForm';
import { PepConnectionRelationPath } from 'modules/client/common/helpers';

export interface FormContentProps {
  notRequestInformation?: boolean;
  pepConnectionRelationLabel?: string;
}

export const FormContent = ({
  notRequestInformation,
  pepConnectionRelationLabel,
}: FormContentProps) => {
  const { values } = useFormContext();
  const { t } = useTranslation();

  const shouldShowPepRelationFields = useMemo(() => {
    const isPepSpouse =
      values.pepConnection?.relation?.value === RelationType.yesSpouses;
    return !notRequestInformation && isPepSpouse;
  }, [notRequestInformation, values.pepConnection?.relation?.value]);

  return (
    <GridFields>
      <Field.Autocomplete
        showRequiredMark
        label={
          pepConnectionRelationLabel ??
          t('client.client.pepConnection.relation.label')
        }
        name="pepConnection.relation"
        optionLabelKey="label"
        options={Object.values(RelationType).map((v) => ({
          label: t(PepConnectionRelationPath[v]),
          value: v,
        }))}
        optionValueKey="value"
        placeholder={t('client.client.pepConnection.relation.placeholder')}
        variant="select"
      />
      {shouldShowPepRelationFields && (
        <>
          <Field.Text
            fullWidth
            showRequiredMark
            label={t('client.client.pepConnection.lastName.label')}
            name="pepConnection.lastname"
            placeholder={t('client.client.pepConnection.lastName.placeholder')}
            trim="start"
          />
          <Field.Text
            fullWidth
            showRequiredMark
            label={t('client.client.pepConnection.firstName.label')}
            name="pepConnection.firstname"
            placeholder={t('client.client.pepConnection.firstName.placeholder')}
            trim="start"
          />
          <Field.Text
            fullWidth
            label={t('client.client.pepConnection.middleName.label')}
            name="pepConnection.surname"
            placeholder={t(
              'client.client.pepConnection.middleName.placeholder'
            )}
            trim="start"
          />
          <Field.Text
            fullWidth
            showRequiredMark
            label={t('client.client.pepConnection.workName.label')}
            name="pepConnection.workName"
            placeholder={t('client.client.pepConnection.workName.placeholder')}
          />
          <Field.Text
            fullWidth
            showRequiredMark
            label={t('client.client.pepConnection.position.label')}
            name="pepConnection.position"
            placeholder={t('client.client.pepConnection.position.placeholder')}
          />
        </>
      )}
    </GridFields>
  );
};
